import { CellContext } from "@tanstack/react-table";
import { useState } from "react";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
// import { SimplifiedInputField } from "../../BaseComponents/SimplifiedInputField";
import { IdentifiableRow } from "../reactiveTableRenderer";

export const DisplayCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, divStyleOverride, styleOverrideOnValue = true, cell}: CellContext<T, string | undefined> & EditAbleCell) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const divStyle = divStyleOverride ? divStyleOverride(styleOverrideOnValue ? value : row.original.id) : undefined;
  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value, row);
    }
  }
  
  return <StyledDisplayCell staticColumn={staticColumn} key={cell.id} keyPass={cell.id + "Input"} onBlur={onBlur} onChange={(e: string) => setValue(e)} canEdit={canEdit} cellData={{value, style: divStyle}} />
}

const StyledDisplayCell = ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn}: StyledTableCellProps & EditAbleCell) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 1  }} key={keyPass}>
          {String(cellData.value) ?? ''}
        </div>
      );
    } else {
      return ( 
        <div style={{ ...cellData.style, opacity: 1  }} key={keyPass}>
          {String(cellData.value) ?? ''}
        </div>
      )
    }
  }

  return (cellData.value)

}